import React, {useEffect, useState} from "react";
import {useParams} from 'react-router-dom';
import axios from 'axios';
import Swal from 'sweetalert2';
import {baseUrl, ipAddress, userLocation, userName} from '../Univ.js'
function EditGeneric() {
    const {id} = useParams();
    const [errorMsg, seterrorMsg] = useState('');
    const [succesMsg, setsuccessMsg] = useState('');
    const [manus, setManus] = useState([]);
    const [registerFormData, setRegisterFormData] = useState({
        "manu": '',
        "product": '',
        "schedule": '',
        "min": '',
        "max": '',
        "alert": '',
        "fav": '',
        "generic": '',
        "addedby": '',
        "ip_add": '',
    });
    useEffect(() => {
        try {
            axios.get(baseUrl + 'update-pharm-qty/' + id + '/')
                .then(function (response) {
                    setRegisterFormData({
                        manu: response.data.manu?.id,
                        product: response.data.product,
                        schedule: response.data.schedule,
                        min: response.data.min,
                        max: response.data.max,
                        alert: response.data.alert,
                        fav: response.data.fav,
                        generic: response.data.generic,
                    });
                });
        } catch (error) {
            console.log(error);
        }
    }, []);
    useEffect(() => {
        try {
            axios.get(baseUrl + 'add-manufacturer/')
                .then(function (response) {
                    setManus(response.data);
                });
        } catch (error) {
            console.log(error);
        }
    }, []);
    const handleChange = (event) => {
        setRegisterFormData({
            ...registerFormData, [event.target.name]: event.target.value
        });
    };
    const submitHandler = (e) => {
        e.preventDefault();
        const manu = document.getElementById("manu").value;
        const formData = new FormData();
        formData.append('product', registerFormData.product);
        formData.append('generic', registerFormData.generic);
        formData.append('schedule', registerFormData.schedule);
        formData.append("min", registerFormData.min ?? "");
        formData.append("max", registerFormData.max ?? "");
        formData.append("alert", registerFormData.alert ?? "");
        formData.append("fav", registerFormData.fav ?? "");
        formData.append('manu', registerFormData.manu);
        formData.append('status', '1');
        formData.append('addedby', userName);
        formData.append('ip_add', ipAddress);
        formData.append('location', userLocation);
        axios.post(baseUrl + 'add-generic/', formData)
            .then((response) => {
                if (response.status == 200 || response.status == 201) {
                    Swal.fire({
                        title: 'Drug has been added.', icon: 'success', timer: 2000, showConfirmButton: false
                    });
                    setTimeout(() => {
                        window.location.href = '/drug-generic/';
                    }, 2000);
                }
            })
            .catch(error => {
                console.log(error);
                Swal.fire('Error!', 'Failed to add drug. Please try again later.', 'error');
            });
    };
    return (<section className="container mt-4">
            <div className="row">
                <div className="col-md-8 col-12">
                    <div className='card'>
                        <h4 className='card-header text-center'>Edit Drug Generic</h4>
                        <div className='card-body'>
                            <p className="text-muted"><strong>Note:</strong>All are Mandatory Fields</p>
                            {succesMsg && <p className="text-success">{succesMsg}</p>}
                            {errorMsg && <p className="text-danger">{errorMsg}</p>}
                            <form>
                                <div className="row">
                                    <div className="col-md-3 mb-3">
                                        <label htmlFor="manu" className="form-label">Manufacturer</label>
                                        <select name="manu" id="manu" value={registerFormData?.manu}
                                                onChange={handleChange} className="form-control">
                                            <option>Choose Manufacturer</option>
                                            {manus.map((manuf, index) => {
                                                return <option key={index} value={manuf?.id}>{manuf.name}
                                                </option>
                                            })}
                                        </select>
                                    </div>
                                    <div className="col-md-5 mb-3">
                                        <label htmlFor="product" className="form-label">Drug Name</label>
                                        <input type="text" placeholder="Drug Name" className="form-control"
                                               name="product" value={registerFormData.product} onChange={handleChange}/>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-5 mb-3">
                                        <label htmlFor="generic" className="form-label">Generic</label>
                                        <input type="text" placeholder="expiry" className="form-control"
                                               name="generic" value={registerFormData.generic} onChange={handleChange}/>
                                    </div>
                                    <div className="col-md-3 mb-3">
                                        <label htmlFor="type" className="form-label">Type</label>
                                        <input type="text" placeholder="Type" className="form-control"
                                               name="schedule" value={registerFormData.schedule}
                                               onChange={handleChange}/>
                                    </div>
                                    <div className="col-md-3 mb-3">
                                        <label htmlFor="min" className="form-label">Min</label>
                                        <input
                                            type="number"
                                            step="any"
                                            id="min"
                                            name="min"
                                            placeholder="Min"
                                            className="form-control"
                                            value={registerFormData.min ?? ""}
                                            onChange={handleChange}
                                        />
                                    </div>

                                    <div className="col-md-3 mb-3">
                                        <label htmlFor="max" className="form-label">Max</label>
                                        <input
                                            type="number"
                                            step="any"
                                            id="max"
                                            name="max"
                                            placeholder="Max"
                                            className="form-control"
                                            value={registerFormData.max ?? ""}
                                            onChange={handleChange}
                                        />
                                    </div>

                                    <div className="col-md-3 mb-3">
                                        <label htmlFor="alert" className="form-label">Alert</label>
                                        <input
                                            type="number"
                                            step="any"
                                            id="alert"
                                            name="alert"
                                            placeholder="Alert"
                                            className="form-control"
                                            value={registerFormData.alert ?? ""}
                                            onChange={handleChange}
                                        />
                                    </div>

                                    <div className="col-md-3 mb-3">
                                        <label htmlFor="fav" className="form-label">Fav</label>
                                        <div className="input-group">
                                        <span className="input-group-text">
                                            <i className="fa-solid fa-star"/>
                                        </span>
                                            <select
                                                id="fav"
                                                name="fav"
                                                className="form-select"
                                                value={registerFormData.fav ?? ""}
                                                onChange={handleChange}
                                            >
                                                <option value="">Select Type</option>
                                                {["Kidney", "Normal", "Testis", "Penis Meatus", "Abdomen"].map((o) =>
                                                    <option key={o} value={o}>{o}</option>)}
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-12 text-center">
                                        <button type="button" onClick={submitHandler}
                                                className="btn btn-success">Update
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </section>);
}
export default EditGeneric;
